import MappingOrigin from "~/models/mapping/mappingOrigin";
import ModelMappingOriginForm from "~/models/mapping/modelMappingOriginForm";
import ModelMappingOriginObjectModel from "~/models/mapping/modelMappingOriginObjectModel";
import ModelMappingOriginFormElement from "~/models/mapping/modelMappingOriginFormElement";
import ModelMappingOriginSalesforce from "~/models/mapping/modelMappingOriginSalesforce";
import ModelMappingOriginSChildRelationship from "~/models/mapping/modelMappingOriginSChildRelationship";
import ModelMappingOriginSReferenceField from "~/models/mapping/modelMappingOriginSReferenceField";
import assertNever from "../../../global/assetNever";
import {ModelType} from "~/enums/modelType";
import {TModelMappingOriginType} from "~/interfaces/mappingInterfaces";
import MappingOriginSalesforce from "~/models/mapping/mappingOriginSalesforce";
import ModelMapping from "~/models/mapping/modelMapping";
import ModelMappingOriginRelationIdentifier from "~/models/mapping/modelMappingOriginRelationIdentifier";
import ModelMappingOriginLookupField from "~/models/mapping/modelMappingOriginLookupField";
import ModelMappingOriginPaymentStep from "~/models/mapping/modelMappingOriginPaymentStep";
import ModelMappingOriginPaymentStepLineItem from "~/models/mapping/modelMappingOriginPaymentStepLineItem";


export type ModelMappingOriginTypes = ModelMappingOriginSalesforce | ModelMappingOriginFormElement | ModelMappingOriginForm | ModelMappingOriginObjectModel | ModelMappingOriginSChildRelationship | ModelMappingOriginSReferenceField | ModelMappingOriginLookupField;
export const ModelMappingOriginSFKlasses = [ModelMappingOriginSalesforce, ModelMappingOriginSChildRelationship, ModelMappingOriginSReferenceField];

export default class ModelMappingOriginFactory {
  static getClass(type: TModelMappingOriginType) {
    switch (type) {
      case  ModelType.Form:
        return ModelMappingOriginForm
      case ModelType.ObjectModel:
        return ModelMappingOriginObjectModel
      case ModelType.FormElement:
        return ModelMappingOriginFormElement
      case ModelType.PaymentStep:
        return ModelMappingOriginPaymentStep
      case ModelType.PaymentStepLineItem:
        return ModelMappingOriginPaymentStepLineItem
      case ModelType.LookUpField:
        return ModelMappingOriginLookupField;
      case ModelType.SObject:
        return ModelMappingOriginSalesforce
      case ModelType.SObjectChildRelationship:
        return ModelMappingOriginSChildRelationship
      case ModelType.SObjectReferenceField:
        return ModelMappingOriginSReferenceField
      case ModelType.RelationIdentifier:
        return ModelMappingOriginRelationIdentifier
      default:
        assertNever(type)
    }
  }

  static create(type: TModelMappingOriginType, id: string, modelMapping: ModelMapping, mappingOrigin: MappingOrigin): ModelMappingOriginTypes {
    if (type === ModelType.SObject) {
      const klass = ModelMappingOriginFactory.getClass(type) as typeof ModelMappingOriginSalesforce
      if (mappingOrigin instanceof MappingOriginSalesforce) {
        return new klass(id, modelMapping, mappingOrigin)
      }
    } else {
      const klass = ModelMappingOriginFactory.getClass(type) as typeof ModelMappingOriginForm | typeof ModelMappingOriginObjectModel | typeof ModelMappingOriginFormElement | typeof ModelMappingOriginLookupField
      return new klass(id, modelMapping, mappingOrigin)
    }
  }
}